import { render, staticRenderFns } from "./FilingSystem.vue?vue&type=template&id=42fae304&scoped=true"
import script from "./FilingSystem.vue?vue&type=script&lang=js"
export * from "./FilingSystem.vue?vue&type=script&lang=js"
import style0 from "./FilingSystem.vue?vue&type=style&index=0&id=42fae304&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fae304",
  null
  
)

export default component.exports